import React from 'react'
import cx from 'classnames'

import { AccordionContext } from './../../context'

import styles from './Panel.module.scss'

type PanelProps = {
  children?: React.ReactNode
  className?: string
}

export const Panel = ({ children, className }: PanelProps) => {
  const { isOpen } = React.useContext(AccordionContext)

  return (
    <div
      className={cx(
        styles.panel,
        {
          [styles.opened]: isOpen,
        },
        className,
      )}
    >
      <div className={styles.content}>{children}</div>
    </div>
  )
}
